var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
export class PreventionChapterMarkerFullSizeDto {
    id;
    createdAt;
    updatedAt;
    markerSeconds;
    chapterName;
    preventionCourseModuleSectionId;
    preventionCourseModuleSection;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PreventionChapterMarkerFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterMarkerFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterMarkerFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionChapterMarkerFullSizeDto.prototype, "markerSeconds", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionChapterMarkerFullSizeDto.prototype, "chapterName", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], PreventionChapterMarkerFullSizeDto.prototype, "preventionCourseModuleSectionId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionChapterMarkerFullSizeDto.prototype, "preventionCourseModuleSection", void 0);
//# sourceMappingURL=prevention-chapter-marker.full-size.dto.js.map